import { Cart, V3VariantFragment } from "./graphql/generated";

export enum LOGIN_LOCATION_ENUM {
  header = "header",
  checkoutModal = "checkoutModal",
  checkoutSubscriptionModal = "checkoutSubscriptionModal",
}

export enum PAGE_TYPE_ENUM {
  home = "home",
  collection = "collection",
  product = "product",
  cart = "cart",
  checkout = "checkout",
  order = "order",
  search = "search",
  account = "account",
  contact = "contact",
  support = "support",
  legal = "legal",
  other = "other",
  marketing = "marketing",
}

export type SCREEN_SIZES = "xl" | "l" | "m" | "s" | "xs";

export interface ShopPageViewAnalyticsData {
  event: EVENT_NAMES.pageView;
  page: {
    location: string;
    path: string;
    id: string;
    type: PAGE_TYPE_ENUM;
    title: string;
    breakpoint: SCREEN_SIZES;
    isRedirect: boolean;
    brand: string;
    referrer?: string;
    source: string;
    medium: string;
    campaign: string;
    term: string;
    content: string;
    noInteraction: false;
    pageCategory?: string;
  };
}

export interface AnalyticsData {
  event: EVENT_NAMES;
  leadType?: string;
  leadSource?: string;
  userToken?: string;
  dateOfBirth?: string;
  item?: V3VariantFragment | null;
  qty?: number;
  page?: string;
  referrer?: string;
  source?: string;
  medium?: string;
  campaign?: string;
  term?: string;
  isEmployerSignUp?: boolean;
  isWeWorkSignUp?: boolean;
  noInteraction?: boolean;
  cart?: Partial<Cart> | { subtotal?: number };
  loginLocation?: LOGIN_LOCATION_ENUM;
  email?: string;
  pageName?: string;
  popularBrand?: string;
  bestSellerTitle?: string;
  categoryTitle?: string;
  navigationName?: string;
  oldQuantity?: number;
  newQuantity?: number;
  intervalDays?: number | null;
  modalName?: string;
  step?: number;
  category?: string;
  action?: string;
  label?: string;
  nonInteraction?: boolean;
  formId?: string;
}

export interface FullShopPageViewAnalyticsData
  extends ShopPageViewAnalyticsData {
  email: boolean | string;
  username?: string;
}

export interface FullAnalyticsData extends Omit<AnalyticsData, "email"> {
  email: boolean | string;
  username?: string;
}

export interface QueryStringAttributes {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  isEmployerSignUp?: string;
  isWeWorkSignUp?: string;
  isSignup?: string;
  returnUrl?: string;
}

export enum EVENT_NAMES {
  addressVerified = "addressVerified",
  bestSellersClick = "bestSellersClick",
  bundleProductClicked = "productClicked",
  cartCheckoutButton = "cartCheckoutButtonClicked",
  cartLineItem = "cartLineItemQtyChanged",
  cartLoginRedirect = "cartLoginRedirect",
  cartOutOfStock = "cartOutOfStockErrorDisplayed",
  cartViewed = "cartViewed",
  categoryClick = "categoryClick",
  generateLead = "generateLead",
  landingPageLogin = "landingPageLogin",
  loqateAutocompleteAddressSelected = "loqate.autocompleteAddressSelected",
  loqateAutocompleteInitiated = "loqate.autocompleteInitiated",
  modalClosed = "modalClosed",
  navigationClick = "navigationClick",
  pageView = "pageView",
  popularBrandsClick = "popularBrandsClick",
  productDetailBuyButton = "productDetailBuyButtonClicked",
  productOneTimePurchaseSelected = "product.oneTimePurchaseSelected",
  productSubAndSaveSelected = "product.subAndSaveSelected",
  productTileBuyButton = "productTileBuyButtonClicked",
  productViewed = "productViewed",
  unverifiedAddressSelected = "unverifiedAddressSelected",
  userChanged = "userChanged",
  userContinueAsGuest = "userContinueAsGuest",
  userLogin = "userLogin",
  userLoginSuccess = "signIn",
  userSignUp = "userSignUp",
  userSignupSuccess = "signup",
  formView = "formView",
  formStart = "formStart",
  formFail = "formFail",
  formAbandonment = "formAbandonment",
  viewItemList = "viewItemList",
  viewPromotion = "viewPromotion",
  selectPromotion = "selectPromotion",
  formSubmit = "formSubmit",
  formExit = "formExit",
}

export interface AnalyticsSessionParamsType {
  utm_campaign?: string;
  utm_term?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_content?: string;
  page_location?: string;
}

export interface AnalyticsSessionParamsContextType {
  analyticsSessionParams?: AnalyticsSessionParamsType | null;
}

export interface LogPageViewParams {
  pageType: PAGE_TYPE_ENUM;
  pageCategory?: string;
  pageTitle: string;
  id: string;
  sessionAtributes?: AnalyticsSessionParamsType;
}
